"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var event_1 = require("./event");
var checkpoint_1 = require("./checkpoint");
var AppBackground = /** @class */ (function (_super) {
    __extends(AppBackground, _super);
    function AppBackground() {
        var _this = this;
        var checkpointEvent = checkpoint_1.default.Start("dive_background_checkpoint", false);
        if (!checkpointEvent) {
            throw new Error("An error occurred while trying to instantiate the appBackground event. It may be because an instance of this event already exists.");
        }
        _this = _super.call(this, "appBackground", {
            id: checkpointEvent.getUuid()
        }) || this;
        return _this;
    }
    AppBackground.prototype._isPrefab = function () {
        return true;
    };
    return AppBackground;
}(event_1.default));
exports.default = AppBackground;
//# sourceMappingURL=appBackground.js.map